import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './driver-binding.css'
import grupos from '../../../data/cdcGroups.json'
import { Table } from "reactstrap";
import TollTipChildren from "../../../components/tolltip-children/TollTipChildren";



class DriverBinding extends React.Component {
    columns = [
        "Origem",
        "Destino",
        "Carga /  Coleta",
        "Data Expedição",
        "Data Aceite",
        "Data Planejada",
        "Motorista",
        "Tipo do Equipamento",
        "Frota Cavalo",
        "Equipamento",
        "Validação",
    ]


    constructor(props) {
        super(props)

        this.state = {
            alert: { msg: 'Preecha os filtros para começar', type: '' },
            mgTab: '30px',
            grupos: [],
            motoristas: [],
            cavalos: [],
            carretas: [],
            biTrens: [],
            origens: { options: [], loadingD: false },
            destinos: { options: [], loadingD: false },
            licenseNumbers: { options: [], loadingD: false },
            toast: [],
            table: [],
            driver: {},
            filter: {
                dataInicio: getFDate(),
                dataFim: getFDate(),
                origem: "",
                destino: "",
                grupo: grupos[1].value,
                numCarga: ""
            },

        }
    }

    componentDidMount = () => {
        this.getCargaMotorista()
    }


    getCargaMotorista = () => {
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        axios.post(`${url}/v1/telemetria/controleCarga/expedicao/cargaMotoristaVeiculo/list/${this.props.token}`, this.state.filter)
            .then(d => {
                // console.log(d.data)
                if (d.data.length) {
                    this.setState({ table: d.data, loading: false })
                } else {
                    this.setState({ alert: { msg: "Não foi possivel localizar resultados para o período selecionado.", type: '' }, loading: false })
                }
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    }




    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, dataInicio: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.dataInicio} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, dataFim: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.dataInicio}
                        min={this.state.filter.dataInicio}
                        
                        value={this.state.filter.dataFim}
                    />
                </div>
                <div>
                    <label htmlFor="carga-coleta" className='toolbar-label'>Carga / Coleta</label>
                    <input
                        id='carga-coleta'
                        placeholder="Carga"
                        className='form-control toolbar-date'
                        onChange={(e) => this.setState({ filter: { ...this.state.filter, numCarga: e.target.value } })}
                        type="number"
                        disabled={this.state.loading}
                        value={this.state.filter.orgiem}
                    />
                </div>
                <div>
                    <label htmlFor="origem" className='toolbar-label'>Origem</label>
                    <input
                        id='origem'
                        placeholder="Origem"
                        maxLength={3}
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, origem: i.target.value } })}
                        disabled={this.state.loading}
                        value={this.state.filter.orgiem}
                    />
                </div>
                <div>
                    <label htmlFor="destino" className='toolbar-label'>Destino</label>
                    <input
                        id='destino'
                        placeholder="Destino"
                        maxLength={3}
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, destino: i.target.value } })}
                        disabled={this.state.loading}
                        value={this.state.filter.destino}
                    />
                </div>

                <div>
                    <label htmlFor="groups" className='toolbar-label'>Grupo</label>
                    {/* Select Grupos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Grupo"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={grupos}
                        closeMenuOnSelect={true}
                        defaultValue={grupos[1]}
                        onChange={(i) => {
                            console.log(i)
                            this.setState({ filter: { ...this.state.filter, grupo: i.value } })
                        }}
                        isDisabled={this.state.loading} />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getCargaMotorista()}
                    disabled={!this.state.filter.dataInicio || !this.state.filter.dataFim || this.state.filter.grupo < 1 || this.state.loading}
                />

            </ToolBar>
        )
    }

    onChangeDataPlanejada = (val, ind) => {
        console.log(val.replace('T', ' '))
        let table = this.state.table
        table[ind].dataPlanejada = val.replace('T', ' ')
        this.setState({ table })
    }
    onChangeMotoristas = (val, ind) => {
        // this.setState({ mgTab: '50px' })

        if (val.length > 2) {
            this.checkMG(ind)
            this.getMotoristas(val, ind);
        }
    };

    checkMG = (i) => {
        // console.log(this.state.table.length - i)
        const subs = this.state.table.length - i

        if (subs === 1) {
            this.setState({ mgTab: '210px' })
        } else if (subs === 2) {
            this.setState({ mgTab: '140px' })
        } else if (subs === 3) {
            this.setState({ mgTab: '90px' })
        }

    }

    getBiTrens = (val, ind) => {
        let biTrens = this.state.biTrens
        biTrens[ind] = { options: [], loadingD: true }
        this.setState({ biTrens });
        axios
            .get(
                `${url}/v1/telemetria/controleCarga/carreta/${encodeURI(val)}/${this.props.token
                }`
            )
            .then(d => {
                // console.log(d)
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i].codigo,
                        label: `${d.data[i].frota} - ${d.data[i].placa}`
                    });
                }
                //console.log(drivers);
                biTrens[ind] = { options, loadingD: false }
                this.setState({ biTrens });
            })
            .catch(e => console.log(e.response));
    };

    getCavalos = (val, ind) => {
        let cavalos = this.state.cavalos
        cavalos[ind] = { options: [], loadingD: true }
        this.setState({ cavalos });
        axios
            .get(
                `${url}/v1/telemetria/controleCarga/cavalo/${encodeURI(val)}/${this.props.token
                }`
            )
            .then(d => {
                // console.log(d)
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i].codigo,
                        label: `${d.data[i].frota} - ${d.data[i].placa}`
                    });

                }
                //console.log(drivers);
                cavalos[ind] = { options, loadingD: false }
                this.setState({ cavalos });
            })
            .catch(e => console.log(e.response));
    };

    getCarretas = (val, ind) => {
        let carretas = this.state.carretas
        carretas[ind] = { options: [], loadingD: true }
        this.setState({ carretas });
        axios
            .get(
                `${url}/v1/telemetria/controleCarga/carreta/${encodeURI(val)}/${this.props.token
                }`
            )
            .then(d => {
                // console.log(d)
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i].codigo,
                        label: `${d.data[i].frota} - ${d.data[i].placa}`
                    });
                }
                //console.log(drivers);
                carretas[ind] = { options, loadingD: false }
                this.setState({ carretas });
            })
            .catch(e => console.log(e.response));
    };

    getMotoristas = (val, ind) => {
        let motoristas = this.state.motoristas
        motoristas[ind] = { options: [], loadingD: true }
        this.setState({ motoristas });
        axios
            .get(
                `${url}/v1/telemetria/admin/cache/drivers/${encodeURI(val)}/${this.props.token
                }`
            )
            .then(d => {
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i].driverObjectId,
                        label: d.data[i].driverName
                    });
                }
                //console.log(drivers);
                motoristas[ind] = { options, loadingD: false }
                this.setState({ motoristas });
            })
            .catch(e => console.log(e.response));
    };


    handleChangeMotoristas = (val, ind) => {

        let table = this.state.table
        if (!val) {
            table[ind].driverId = ''
            this.setState({ table })
            return;
        }
        table[ind].driverId = val.value
        this.setState({ table, mgTab: '30px' })
    }

    handleChangeEquipamento = (val, ind) => {
        let table = this.state.table
        if (!val || val.value === "carreta") {
            table[ind].isVeiculoBitrem = false
            table[ind].bitrem = ''
            this.setState({ table })
            return;
        }
        table[ind].isVeiculoBitrem = true
        table[ind].bitrem = ''
        this.setState({ table })

    }
    handleChangeCavalos = (val, ind) => {
        let table = this.state.table

        if (!val) {
            table[ind].cavalo = ''
            this.setState({ table })
            return;
        }
        table[ind].cavalo = val.label
        this.setState({ table, mgTab: '30px' })
    }
    onChangeCavalos = (val, ind) => {
        // console.log(val, ind)

        if (val.length > 2) {
            this.checkMG(ind)
            this.getCavalos(val, ind);
        }
    };
    handleChangeCarretas = (val, ind) => {
        let table = this.state.table

        if (!val) {
            table[ind].carreta = ''
            this.setState({ table })
            return;
        }
        table[ind].carreta = val.label
        this.setState({ table, mgTab: '30px' })


    }
    onChangeCarretas = (val, ind) => {
        // console.log(val, ind)

        if (val.length > 2) {
            this.checkMG(ind)
            this.getCarretas(val, ind);
        }
    };
    handleChangeBiTrens = (val, ind) => {
        let table = this.state.table
        if (!val) {
            table[ind].bitrem = ''
            this.setState({ table })
            return;
        }
        table[ind].bitrem = val.label
        this.setState({ table, mgTab: '30px' })

    }

    onChangeBiTrens = (val, ind) => {
        // console.log(val, ind)

        if (val.length > 2) {
            this.checkMG(ind)
            this.getBiTrens(val, ind);
        }
    };

    check = i => {
        let body = this.state.table[i]
        console.log(body)
        this.save(body)
    }

    save = body => {
        this.setState({ loading: true })
        axios.post(`${url}/v1/telemetria/controleCarga/expedicao/cargaMotoristaVeiculo/save/${this.props.token}`, body)
            .then(d => {
                if (body.validado) {
                    store.addNotification({ ...this.props.bodyNotify, title: `${body.numCarga} Validada!`, type: 'success' });
                }
                this.getCargaMotorista()
            })
            .catch(e => {
                console.log(e.response)
                store.addNotification({ ...this.props.bodyNotify, title: e.response.data.errorMessage[0], type: 'danger' });
            })
    }

    //No option selects
    noOptionsMessage = (e, sel) => {
        if (e.inputValue === "") {
            return sel === "driver"
                ? "Pesquise os motoristas!"
                : sel === "license"
                    ? "Pesquise as frotas!"
                    : sel === "failure" ? "Pesquise falhas"
                        : null;
        } else {
            return `${e.inputValue}: não foi encontrado!`;
        }
    };


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div style={{ marginRight: '5px' }}>

                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    {/* {this.columns.map((d, i) => {
                                        return (
                                            <th key={i} style={{minWidth: '100px'}}>{d}</th>
                                            )
                                        })} */}
                                        <th style={{minWidth: '150px', }}>Origem</th>
                                        <th style={{minWidth: '120px', }}>Destino</th>
                                        <th style={{minWidth: '120px', }}>Carga / Coleta</th>
                                        <th style={{minWidth: '120px', }}>Data Expedição</th>
                                        <th style={{minWidth: '120px', }}>Data Aceite</th>

                                        <th style={{minWidth: '236px', }}>Data Planejada</th>

                                        <th style={{minWidth: '216px',width: '216px' }}>Motorista</th>
                                        <th style={{minWidth: '216px',width: '216px' }}>Tipo do Equipamento</th>
                                        <th style={{minWidth: '216px',width: '216px' }}>Frota Cavalo</th>
                                        <th style={{minWidth: '216px',width: '216px'}}>Equipamento</th>

                                        <th style={{minWidth: '60px', width: '60px'}}>Validação</th>
                                </tr>
                            </thead>
                            <tbody style={{maxHeight: '75vh'}}>
                                {this.state.table.map((d, i) => {
                                    const mgTopText = '20px'
                                    const mgTopSelect = '0px'
                                    let date = ''
                                    if (d.dataPlanejada.indexOf('/') > 0) {
                                        const dt = d.dataPlanejada.split('/')
                                        const h = dt[2].split(' ')
                                        date = `${h[0]}-${dt[1]}-${dt[0]}T${h[1]}`
                                    }

                                    const disabled = !d.podeAlterar
                                    if(d.rejeitado) console.log('tem')
                                    return (
                                        
                                        <tr key={i} className={`${d.rejeitado ? 'tr-rejeitado' : ''} tr-table-change-color`}>
                                            <td className='td-table-journey-control td-txt-controle-carga' style={{ paddingTop: mgTopText, minWidth: '150px', }}>
                                                <div style={{ maxWidth: '200px' }} className="">
                                                    {d.origem}
                                                </div>
                                            </td>
                                            <td className='td-table-journey-control td-txt-controle-carga' style={{ paddingTop: mgTopText, minWidth: '120px', }}>
                                                <div style={{ maxWidth: '200px' }} className="">
                                                    {d.destino}
                                                </div>
                                            </td>
                                            <td className='td-table-journey-control td-txt-controle-carga' style={{ paddingTop: mgTopText, minWidth: '120px', }}>{d.numCarga}</td>
                                            <td className='td-table-journey-control td-txt-controle-carga' style={{ paddingTop: mgTopText, minWidth: '120px', }}>{d.dataProgExpedicao}</td>
                                            <td className='td-table-journey-control td-txt-controle-carga' style={{ paddingTop: mgTopText, minWidth: '120px', }}>{d.dataAceite}</td>
                                            <td className='td-table-journey-control' style={{ paddingTop: mgTopText, minWidth: '220px', }}>
                                                <input
                                                    type='datetime-local'
                                                    className='input-change-color form-control'
                                                    style={{ marginTop: '-10px', maxWidth: '220px' }}
                                                    defaultValue={date.length ? `${date}` : undefined}
                                                    onChange={(e) => this.onChangeDataPlanejada(e.target.value, i)}
                                                    disabled={disabled}
                                                />
                                            </td>
                                            <td className='td-table-journey-control' style={{ minWidth: '220px', width: '220px' }}>
                                                <div>
                                                    <Select
                                                        isLoading={this.state.motoristas[i] ? this.state.motoristas[i].loadingD : false}
                                                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                                                        placeholder="Motorista"
                                                        noOptionsMessage={e => this.noOptionsMessage(e, "detino")}
                                                        options={this.state.motoristas[i] ? this.state.motoristas[i].options : []}
                                                        closeMenuOnSelect={true}
                                                        onChange={(val) => this.handleChangeMotoristas(val, i)}
                                                        onInputChange={(val) => this.onChangeMotoristas(val, i)}
                                                        isDisabled={disabled || this.state.loading}
                                                        isClearable
                                                        className='select-in-table'
                                                        defaultValue={d.driverName.length ? { label: d.driverName, value: 0 } : undefined}
                                                    />
                                                </div>

                                            </td>
                                            <td className='td-table-journey-control' style={{ minWidth: '200px', width: '200px' }}>
                                                <div style={{ paddingTop: mgTopSelect }}>
                                                    <Select
                                                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                                                        placeholder="Equipamento"
                                                        noOptionsMessage={e => this.noOptionsMessage(e, "detino")}
                                                        options={[
                                                            { value: 'carreta', label: d.tipoVeiculo || 'Carreta' },
                                                            { value: 'bitrem', label: 'Bi Trem' }
                                                        ]}
                                                        closeMenuOnSelect={true}
                                                        onChange={(val) => this.handleChangeEquipamento(val, i)}
                                                        isDisabled={disabled || this.state.loading}
                                                        isClearable
                                                        className='select-in-table'
                                                        defaultValue={{ label: d.isVeiculoBitrem ? 'Bi Trem' : d.tipoVeiculo || 'Carreta', value: 0 }}

                                                    />
                                                </div>

                                            </td>
                                            <td className='td-table-journey-control' style={{ minWidth: '200px', width: '200px' }}>
                                                <div style={{ paddingTop: mgTopSelect }}>
                                                    <Select
                                                        isLoading={this.state.cavalos[i] ? this.state.cavalos[i].loadingD : false}
                                                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                                                        placeholder="Cavalo"
                                                        noOptionsMessage={e => this.noOptionsMessage(e, "detino")}
                                                        options={this.state.cavalos[i] ? this.state.cavalos[i].options : []}
                                                        closeMenuOnSelect={true}
                                                        onChange={(val) => this.handleChangeCavalos(val, i)}
                                                        onInputChange={(val) => this.onChangeCavalos(val, i)}
                                                        isDisabled={disabled || this.state.loading}
                                                        isClearable
                                                        className='select-in-table'
                                                        // defaultInputValue={d.cavalo}
                                                        defaultValue={d.cavalo.length ? { label: d.cavalo, value: 0 } : undefined}
                                                    />
                                                </div>
                                            </td>
                                            <td className='td-table-journey-control' style={{ minWidth: '200px', width: '200px' }}>
                                                <div>
                                                    <Select
                                                        isLoading={this.state.carretas[i] ? this.state.carretas[i].loadingD : false}
                                                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                                                        placeholder="Carreta"
                                                        noOptionsMessage={e => this.noOptionsMessage(e, "detino")}
                                                        options={this.state.carretas[i] ? this.state.carretas[i].options : []}
                                                        closeMenuOnSelect={true}
                                                        onChange={(val) => this.handleChangeCarretas(val, i)}
                                                        onInputChange={(val) => this.onChangeCarretas(val, i)}
                                                        isDisabled={disabled || this.state.loading}
                                                        isClearable
                                                        className='select-in-table'
                                                        // defaultInputValue={d.carreta}
                                                        defaultValue={d.carreta.length ? { label: d.carreta, value: 0 } : undefined}
                                                    />
                                                </div>
                                                {d.isVeiculoBitrem ? (
                                                    <div style={{ marginTop: '10px' }}>
                                                        <Select
                                                            isLoading={this.state.biTrens[i] ? this.state.biTrens[i].loadingD : false}
                                                            loadingMessage={i => `Procurando: ${i.inputValue}`}
                                                            placeholder="Bi Trem"
                                                            noOptionsMessage={e => this.noOptionsMessage(e, "detino")}
                                                            options={this.state.biTrens[i] ? this.state.biTrens[i].options : []}
                                                            closeMenuOnSelect={true}
                                                            onChange={(val) => this.handleChangeBiTrens(val, i)}
                                                            onInputChange={(val) => this.onChangeBiTrens(val, i)}
                                                            isDisabled={disabled || this.state.loading}
                                                            isClearable
                                                            className='select-in-table'
                                                            // defaultInputValue={d.bitrem}
                                                            defaultValue={d.bitrem.length ? { label: d.bitrem, value: 0 } : undefined}
                                                        />
                                                    </div>
                                                ) : null}
                                            </td>


                                            <td style={{minWidth: '80px', width: '80px'}}>
                                                <div style={{ paddingTop: mgTopSelect }}>
                                                    <TollTipChildren text='Vincular Carga' id={`check-vinculation-${i}`}>
                                                        <input
                                                            className='checkbox-round'
                                                            type="checkbox"
                                                            checked={d.validado}
                                                            id={`check-vinculation-${i}`}
                                                            onChange={() => this.check(i)}
                                                            disabled={disabled}
                                                        />
                                                    </TollTipChildren>
                                                </div>
                                            </td>

                                        </tr>
                                    )
                                })}


                            </tbody>
                        </Table>

                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default DriverBinding